import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import user from './user_reducer';
import userError from './user_error';
import masterData from './master_data_reducer';
import sales from './salesUser_reducer';

export const userReducer= combineReducers({
  user,
  userError,
  form: formReducer, // donot change the name of the properties
  masterData, sales
});


// WEBPACK FOOTER //
// ./web/reducer/index.js